const MyListConstants = {
    GET_LIST: 'saved-items',
    CAM_BASE: 'accounts',
    GUEST_VIEW: 'share/saved-items',
    GET_TRENDING_LIST: 'saved-items/trending-list',
    COPY_LIST: 'saved-items/copy-list',
};

export default MyListConstants;
